export default "__VITE_ASSET__Br03Swh5__"